(function () {
  'use strict';

  function formatMoneyFromCents(cents) {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return '$' + value.replace('.', ',');
  }

  function openStep(section, group) {
    section.querySelectorAll('.qn-build-bowl__step').forEach(function (step) {
      step.classList.remove('is-open');
      const icon = step.querySelector('.qn-build-bowl__step-toggle-icon');
      if (icon) icon.textContent = '+';
    });

    const target = section.querySelector('.qn-build-bowl__step[data-step-group="' + group + '"]');
    if (target) {
      target.classList.add('is-open');
      const icon = target.querySelector('.qn-build-bowl__step-toggle-icon');
      if (icon) icon.textContent = '−';
    }
  }

  function toggleStep(step) {
    const isOpen = step.classList.contains('is-open');
    const section = step.closest('.qn-build-bowl');

    if (isOpen) {
      step.classList.remove('is-open');
      const icon = step.querySelector('.qn-build-bowl__step-toggle-icon');
      if (icon) icon.textContent = '+';
    } else {
      const group = step.getAttribute('data-step-group');
      openStep(section, group);
    }
  }

  function initBuildBowl(section) {
    const items = section.querySelectorAll('[data-build-bowl-item]');
    const addAllBtn = section.querySelector('[data-build-bowl-add-all]');
    const totalEl = section.querySelector('[data-build-bowl-total]');
    const toggles = section.querySelectorAll('[data-step-toggle]');

    if (!items.length || !addAllBtn || !totalEl) return;

    const state = {
      base: null,
      topping: null,
      extra: null
    };

    const labels = {
      base: section.querySelector('[data-build-bowl-label="base"]'),
      topping: section.querySelector('[data-build-bowl-label="topping"]'),
      extra: section.querySelector('[data-build-bowl-label="extra"]')
    };

    const defaultBtnText = addAllBtn.getAttribute('data-add-label') || 'Agregar combo';
    const loadingBtnText = addAllBtn.getAttribute('data-adding-label') || 'Agregando...';
    const addedBtnText = addAllBtn.getAttribute('data-added-label') || 'Agregado';
    const errorBtnText = addAllBtn.getAttribute('data-error-label') || 'Error';

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        toggleStep(toggle.closest('.qn-build-bowl__step'));
      });
    });

    function updateSummary() {
      let total = 0;

      ['base', 'topping', 'extra'].forEach(function (group) {
        if (state[group]) {
          total += Number(state[group].price || 0);
          if (labels[group]) labels[group].textContent = state[group].title;
        }
      });

      totalEl.textContent = formatMoneyFromCents(total);

      const allSelected = state.base && state.topping && state.extra;
      addAllBtn.disabled = !allSelected;
    }

    function openNextStep(currentGroup) {
      if (currentGroup === 'base') {
        openStep(section, 'topping');
      } else if (currentGroup === 'topping') {
        openStep(section, 'extra');
      }
    }

    function selectItem(button) {
      const group = button.getAttribute('data-group');
      if (!group) return;

      section.querySelectorAll('[data-build-bowl-item][data-group="' + group + '"]').forEach(function (item) {
        item.classList.remove('is-selected');
      });

      button.classList.add('is-selected');

      state[group] = {
        title: button.getAttribute('data-title') || '',
        price: Number(button.getAttribute('data-price') || 0),
        variantId: Number(button.getAttribute('data-variant-id') || 0)
      };

      updateSummary();
      openNextStep(group);
    }

    items.forEach(function (button) {
      button.addEventListener('click', function () {
        selectItem(button);
      });
    });

    addAllBtn.addEventListener('click', function () {
      if (addAllBtn.disabled) return;

      const ids = [state.base, state.topping, state.extra]
        .filter(Boolean)
        .map(function (item) {
          return {
            id: item.variantId,
            quantity: 1
          };
        });

      if (!ids.length) return;

      addAllBtn.disabled = true;
      addAllBtn.textContent = loadingBtnText;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: ids
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Error');
          return response.json();
        })
        .then(function () {
          addAllBtn.textContent = addedBtnText;

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('cart:drawer:open'));

          const cartDrawer =
            document.querySelector('[data-cart-drawer]') ||
            document.querySelector('.qn-cart-drawer') ||
            document.querySelector('#cart-drawer');

          if (cartDrawer) {
            cartDrawer.classList.add('is-open');
            cartDrawer.classList.add('active');
            cartDrawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cart-drawer-open');
            document.body.classList.add('overflow-hidden');
          }

          const cartTrigger =
            document.querySelector('[data-cart-toggle]') ||
            document.querySelector('[data-open-cart]') ||
            document.querySelector('.header__cart') ||
            document.querySelector('.qn-header__cart') ||
            document.querySelector('a[href="/cart"]');

          if (cartTrigger && !cartDrawer?.classList.contains('is-open')) {
            cartTrigger.click();
          }

          setTimeout(function () {
            addAllBtn.textContent = defaultBtnText;
            addAllBtn.disabled = false;
          }, 1300);
        })
        .catch(function () {
          addAllBtn.textContent = errorBtnText;

          setTimeout(function () {
            addAllBtn.textContent = defaultBtnText;
            addAllBtn.disabled = false;
          }, 1300);
        });
    });

    openStep(section, 'base');
    updateSummary();
  }

  function initAllBuildBowl() {
    document.querySelectorAll('.qn-build-bowl').forEach(function (section) {
      if (section.dataset.buildBowlReady === 'true') return;
      section.dataset.buildBowlReady = 'true';
      initBuildBowl(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBuildBowl);
  } else {
    initAllBuildBowl();
  }

  document.addEventListener('shopify:section:load', initAllBuildBowl);
})();